import { Component, OnDestroy } from "@angular/core";
import { trigger, state, transition, style, animate } from "@angular/animations";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../apigee/impersonation.service";

@Component({
    selector: "impersonation-warning",
    templateUrl: "impersonationWarning.component.html",
    styleUrls: ["impersonationWarning.component.css"],
    animations: [
        trigger('show', [
            state('true', style({ "transform": "scale(1)", "transform-origin": "center center", "opacity": "1" })),
            state('false', style({ "transform": "scale(0.75)", "transform-origin": "center center", "opacity": "0" })),
            transition('true => false', animate('300ms ease-in')),
            transition('false => true', animate('300ms ease-out'))
        ])
    ],
    standalone: false
})
export class ImpersonationWarningComponent implements OnDestroy {
    private onAuthTokensUpdated: Subscription;
    private impersonatedName: string;

    constructor(private impersonationService: ImpersonationService) {
        this.onAuthTokensUpdated = this.impersonationService.impersonationChanged.subscribe(() => {
            if (!this.isImpersonating) setTimeout(() => this.impersonatedName = null, 500);
            else this.impersonatedName = this.impersonationService.getUserDisplayName();
        });
    }

    public get isImpersonating(): boolean {
        return this.impersonationService.isImpersonating;
    }

    public get impersonatedUserDisplayName(): string {
        return this.impersonatedName;
    }

    public clearImpersonation(event: Event) {
        if (event) event.stopPropagation();
        this.impersonationService.clearImpersonation();
    }

    public ngOnDestroy() {
        this.onAuthTokensUpdated.unsubscribe();
    }
}
